// Configuration d'environnement centralisée et sécurisée
// Ce fichier ne contient AUCUNE clé API sensible
//
// Référence déploiements Chalice (API/.chalice/deployed/*.json) :
// - Staging : j6tw51n1kl.execute-api… (Lambda rintintin-API-staging)
// - Prod Chalice : naxewuymma.execute-api… (Lambda rintintin-API-prod)
//
// Le backoffice résout l’URL via `apiConfig.ts` : en build production web, API primaire
// w6khpitahj… + secondaire 137jrhqqx9… ; la liste unifiée `/pro/{id}/invoices/unified` part sur l’API primaire.
// Pour pointer le front vers la base / Lambda **staging** : définir au build
// REACT_APP_API_BASE_URL=https://j6tw51n1kl.execute-api.eu-west-3.amazonaws.com/api

import { Capacitor } from '@capacitor/core';

import { resolvePostHogApiHost, resolvePostHogUiHost } from '../analytics/posthogHosts';
import { getApiUrl as getCentralizedApiUrl } from './apiConfig';
import { configService } from '../services/configService';
import {
  hasValidGoogleMapsApiKey,
  resolveGoogleMapsApiKey,
} from './resolveGoogleMapsApiKey';

const getApiUrl = () => {
  // On utilise la logique centralisée qui gère déjà Native, Env Vars et fallback Prod
  return getCentralizedApiUrl('/health');
};

export const ENV_CONFIG = {
  // Configuration de l'API
  API: {
    // Dynamique selon l'environnement
    BASE_URL: getApiUrl(),
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3
  },

  // Configuration de l'application
  APP: {
    NAME: 'Rintintin Backoffice',
    VERSION: process.env.REACT_APP_VERSION || '1.0.90',
    ENVIRONMENT: process.env.NODE_ENV || 'development'
  },

  // Configuration des fonctionnalités
  FEATURES: {
    ENABLE_ANALYTICS: process.env.NODE_ENV === 'production',
    ENABLE_DEBUG_MODE: process.env.NODE_ENV === 'development',
    ENABLE_MOCK_DATA: process.env.NODE_ENV === 'development'
  },

  // Configuration du tracking (publicité)
  TRACKING: {
    META_PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '1788608545412368',
    ENABLED: process.env.NODE_ENV === 'production'
  },

  // PostHog (analytics produit — clé publique côté front)
  POSTHOG: {
    API_HOST: resolvePostHogApiHost(),
    UI_HOST: resolvePostHogUiHost(),
    ENABLED: process.env.NODE_ENV === 'production' || !!process.env.REACT_APP_POSTHOG_KEY,
  },

  // Configuration mobile
  MOBILE: {
    ENABLE_PUSH_NOTIFICATIONS: true,
    ENABLE_OFFLINE_MODE: false,
    ENABLE_BACKGROUND_SYNC: false
  }
};

// Configuration par plateforme (mobile vs web)
// Toujours utiliser l'API de production pour les apps natives
export const getPlatformConfig = () => {
  const isNative = typeof window !== 'undefined' && 'Capacitor' in window;

  if (isNative) {
    // En natif : si REACT_APP_API_BASE_URL est défini au build (ex. test local), on l'utilise
    const nativeBaseUrl = configService.getApiUrl()
    return {
      ...ENV_CONFIG,
      API: {
        ...ENV_CONFIG.API,
        BASE_URL: nativeBaseUrl
      }
    };
  }

  return ENV_CONFIG;
};

// Configuration sécurisée pour les clés sensibles
export const getSecureConfig = () => {
  // Les clés sensibles ne sont JAMAIS exposées ici
  // Elles sont gérées côté serveur uniquement
  // Maps browser key: resolveGoogleMapsApiKey (env + fallback #562).
  return {
    hasGoogleMaps: hasValidGoogleMapsApiKey(resolveGoogleMapsApiKey()),
    hasAnalytics: !!process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
    // Ne jamais retourner les clés elles-mêmes
  };
};
